import { HeatingTypeSelect } from '~src/components/HeatingTypeSelect';
import { HeatingTypeSelectNorlys } from '~src/components/HeatingTypeSelect/norlys';
import { useDisplayContext } from '~src/context/DisplayContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { Residence } from '~src/model';

export const HeatingInformation = () => {
  const { isMobile } = useDisplayContext();

  const { residence, setResidence } = usePublicCalculatorContext();

  return (
    <div style={{ width: '100%' }}>
      <HeatingTypeSelect
        {...{
          style: isMobile ? { padding: '8px 0 0 0' } : undefined,
          label: 'Hvordan fordeles varmen i din bolig?',
          value: residence?.heatDistribution ?? 'radiator',
          onChange: value => setResidence?.({ ...residence, heatDistribution: value as Residence['heatDistribution'] }),
        }}
      />
    </div>
  );
};

export const HeatingInformationNorlys = () => {
  const { residence, setResidence } = usePublicCalculatorContext();

  return (
    <div style={{ width: '100%', marginTop: '32px' }}>
      <HeatingTypeSelectNorlys
        {...{
          label: 'Hvordan fordeles varmen i din bolig?',
          value: residence?.heatDistribution ?? 'radiator',
          onChange: value => setResidence?.({ ...residence, heatDistribution: value as Residence['heatDistribution'] }),
        }}
      />
    </div>
  );
};
